import React from "react";

const AccesoSimultaneo = (props) => {
    return (
        <li>
            <div className="row">
                <div className="col-xs-4">
                    <p className="word-break-all">{props.data.Descripcion + ": "}</p>
                </div>
                <div className="col-xs-8">
                    <p>{props.data.CanLog}</p>
                </div>
            </div>
        </li>
    );
}

export default AccesoSimultaneo;